import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'osp-thumbnail-characters',
  standalone: true,
  imports: [],
  templateUrl: './thumbnail-characters.component.html',
  styleUrl: './thumbnail-characters.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})



export class ThumbnailCharactersComponent {
  @Input() thumbnailLetter: string = '';
}
